import { POPULATION_TYPE, SORTING_DIR } from "@/common/models";
import { IColumn, ITableConfig } from "@/components/table/table.model";

export const getTableConfig = (p: POPULATION_TYPE): ITableConfig => {
  let columns = privateEmails;
  switch (p) {
    case POPULATION_TYPE.FOLDER:
      columns = folders;
      break;
    case POPULATION_TYPE.EMPLOYEE:
      columns = employees;
      break;
    case POPULATION_TYPE.CONTACT:
      columns = contacts;
      break;
    case POPULATION_TYPE.ORGANIZATION:
      columns = organizations;
      break;
    case POPULATION_TYPE.PRIVATE_EMAIL:
    default:
      columns = privateEmails;
      break;
  }
  return {
    columns,
  };
};

const employees: IColumn[] = [
  {
    name: "",
    key: "menu",
    spanMin: "4rem",
    spanMax: "4rem",
    sortable: false,
    filterable: false,
  },
  {
    name: "Name",
    key: "name",
    spanMin: "16rem",
    spanMax: "2fr",
    sortable: false,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: true,
    jsPath: "data.entities[].entities.[0].name",
  },
  {
    name: "Email",
    key: "externalId",
    spanMin: "20rem",
    spanMax: "2fr",
    sortable: false,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].entities.[0].email",
  },
  {
    name: "Department",
    key: "department",
    spanMin: "10rem",
    spanMax: "15rem",
    sortable: false,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].entities.[0].department",
  },
  {
    name: "Events",
    key: "count",
    spanMin: "10rem",
    spanMax: "1fr",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].count",
  },
  {
    name: "First event",
    key: "startDate",
    spanMin: "15rem",
    spanMax: "20rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].startDate",
  },
  {
    name: "Last event",
    key: "endDate",
    spanMin: "15rem",
    spanMax: "20rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.DESC,
    isSortActive: true,
    jsPath: "data.entities[].endDate",
  },
];

const contacts: IColumn[] = [
  {
    name: "",
    key: "menu",
    spanMin: "4rem",
    spanMax: "4rem",
    sortable: false,
    filterable: false,
  },
  {
    name: "Email",
    key: "name",
    spanMin: "20rem",
    spanMax: "2fr",
    sortable: false,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].entities.[0].name",
  },
  {
    name: "Events",
    key: "count",
    spanMin: "10rem",
    spanMax: "15rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].count",
  },
  {
    name: "First event",
    key: "startDate",
    spanMin: "15rem",
    spanMax: "15rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].startDate",
  },
  {
    name: "Last event",
    key: "endDate",
    spanMin: "15rem",
    spanMax: "15rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.DESC,
    isSortActive: true,
    jsPath: "data.entities[].endDate",
  },
];

const privateEmails: IColumn[] = [
  {
    name: "",
    key: "menu",
    spanMin: "4rem",
    spanMax: "4rem",
    sortable: false,
    filterable: false,
  },
  {
    name: "Email",
    key: "name",
    spanMin: "20rem",
    spanMax: "2fr",
    sortable: false,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].entities.[0].name",
  },
  {
    name: "Events",
    key: "count",
    spanMin: "10rem",
    spanMax: "20rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].count",
  },
  {
    name: "First event",
    key: "startDate",
    spanMin: "15rem",
    spanMax: "1fr",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].startDate",
  },
  {
    name: "Last event",
    key: "endDate",
    spanMin: "17rem",
    spanMax: "1fr",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.DESC,
    isSortActive: true,
    jsPath: "data.entities[].endDate",
  },
];

const folders: IColumn[] = [
  {
    name: "",
    key: "menu",
    spanMin: "4rem",
    spanMax: "4rem",
    sortable: false,
    filterable: false,
  },
  {
    name: "Folder name",
    key: "name",
    spanMin: "15rem",
    spanMax: "1fr",
    sortable: false,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: true,
    jsPath: "data.entities[].entities.[0].name",
  },
  {
    name: "Folder Owner/Site",
    key: "ownerOrSite",
    spanMin: "15rem",
    spanMax: "1fr",
    sortable: false,
    filterable: false,
    isSortActive: false,
    jsPath: "data.entities[].entities.[0].ownerOrSite",
  },
  {
    name: "Events",
    key: "count",
    spanMin: "6rem",
    spanMax: "6rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].count",
  },
  {
    name: "First event",
    key: "startDate",
    spanMin: "14rem",
    spanMax: "14rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].startDate",
  },
  {
    name: "Last event",
    key: "endDate",
    spanMin: "14rem",
    spanMax: "14rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.DESC,
    isSortActive: true,
    jsPath: "data.entities[].endDate",
  },
  {
    name: "Application",
    key: "source",
    spanMin: "7rem",
    spanMax: "7rem",
    sortable: false,
    filterable: false,
    isSortActive: false,
    jsPath: "data.entities[].entities.[0].sourceApplication",
  },
  {
    name: "Location URL",
    key: "url",
    spanMin: "12rem",
    spanMax: "12rem",
    sortable: false,
    filterable: false,
    isSortActive: false,
    jsPath: "data.entities[].entities.[0].path",
  },
];

const organizations: IColumn[] = [
  {
    name: "",
    key: "menu",
    spanMin: "4rem",
    spanMax: "4rem",
    sortable: false,
    filterable: false,
  },
  {
    name: "Domain",
    key: "name",
    spanMin: "20rem",
    spanMax: "2fr",
    sortable: false,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].entities.[0].name",
  },
  {
    name: "Events",
    key: "count",
    spanMin: "10rem",
    spanMax: "20rem",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].count",
  },
  {
    name: "First event",
    key: "startDate",
    spanMin: "15rem",
    spanMax: "1fr",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].startDate",
  },
  {
    name: "Last event",
    key: "endDate",
    spanMin: "17rem",
    spanMax: "1fr",
    sortable: true,
    filterable: false,
    sortDir: SORTING_DIR.ASC,
    isSortActive: false,
    jsPath: "data.entities[].endDate",
  },
];
